import { Fragment } from 'react';

import { Name } from './Styled';
import { Content } from '../../campaignIndex/components/CampaignNameCell.styles';

import { SnippetUsage } from '../types';

type Props = {
  result: SnippetUsage;
};

export const UsageTypeCell = ({ result }: Props) => {
  const { id, resultType } = result;

  return (
    <Fragment key={id}>
      <Content data-test="usage-content">
        <Name data-test={`usage-template-type-${id}`}>{resultType}</Name>
      </Content>
    </Fragment>
  );
};
